import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { useApp } from '../context/AppContext';
import { Screen } from '../types';
import { Button } from '../components/ui/Button';
import { Header } from '../components/ui/Header';
export function OTPScreen() {
  const {
    resetTo
  } = useNavigation();
  const {
    setUser
  } = useApp();
  const [otp, setOtp] = useState(['', '', '', '']);
  const [timer, setTimer] = useState(60);
  const [loading, setLoading] = useState(false);
  const inputs = useRef<(HTMLInputElement | null)[]>([]);
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const handleChange = (index: number, value: string) => {
    if (value.length > 1) value = value[0];
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value !== '' && index < 3) {
      inputs.current[index + 1]?.focus();
    }
  };
  const handleKeyDown = (index: number, e: React.KeyboardEvent) => {
    if (e.key === 'Backspace' && otp[index] === '' && index > 0) {
      inputs.current[index - 1]?.focus();
    }
  };
  const handleVerify = () => {
    setLoading(true);
    setTimeout(() => {
      setUser({
        id: 'u1',
        name: 'John Doe',
        email: 'john@example.com'
      });
      resetTo(Screen.HOME);
    }, 1000);
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} className="min-h-screen bg-white flex flex-col" data-id="element-995">
      <Header transparent data-id="element-996" />

      <div className="flex-1 p-6 flex flex-col items-center pt-12" data-id="element-997">
        <div className="w-20 h-20 bg-primary-50 rounded-full flex items-center justify-center mb-6" data-id="element-998">
          <span className="text-3xl" data-id="element-999">✉️</span>
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-1000">
          Verify Your Account
        </h1>
        <p className="text-gray-500 text-center mb-8 px-4" data-id="element-1001">
          We've sent a 4-digit code to your email <br data-id="element-1002" />
          <span className="font-medium text-gray-900" data-id="element-1003">j***@example.com</span>
        </p>

        <div className="flex gap-4 mb-8" data-id="element-1004">
          {otp.map((digit, index) => <input key={index} ref={el => inputs.current[index] = el} type="number" value={digit} onChange={e => handleChange(index, e.target.value)} onKeyDown={e => handleKeyDown(index, e)} className="w-14 h-14 text-center text-2xl font-bold rounded-xl border border-gray-200 focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-all" maxLength={1} data-id="element-1005" />)}
        </div>

        <Button fullWidth size="lg" onClick={handleVerify} loading={loading} disabled={otp.join('').length < 4} data-id="element-1006">
          Verify
        </Button>

        <div className="mt-8 text-center" data-id="element-1007">
          <p className="text-sm text-gray-500 mb-2" data-id="element-1008">Didn't receive the code?</p>
          {timer > 0 ? <p className="text-sm font-medium text-gray-900" data-id="element-1009">
              Resend in {timer}s
            </p> : <button className="text-sm font-bold text-primary hover:underline" data-id="element-1010">
              Resend Code
            </button>}
        </div>
      </div>
    </motion.div>;
}